<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import TriggerNodeEditor from './components/editors/TriggerNodeEditor.vue';
import MessageNodeEditor from './components/editors/MessageNodeEditor.vue';
import BlockNodeEditor from './components/editors/BlockNodeEditor.vue';
import ConditionNodeEditor from './components/editors/ConditionNodeEditor.vue';
import ActionNodeEditor from './components/editors/ActionNodeEditor.vue';
import DataCollectionNodeEditor from './components/editors/DataCollectionNodeEditor.vue';
import DelayNodeEditor from './components/editors/DelayNodeEditor.vue';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  inboxes: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update', 'delete', 'close']);

const editorComponent = computed(() => {
  const map = {
    trigger: TriggerNodeEditor,
    message: MessageNodeEditor,
    block: BlockNodeEditor,
    condition: ConditionNodeEditor,
    action: ActionNodeEditor,
    data_collection: DataCollectionNodeEditor,
    delay: DelayNodeEditor,
  };
  return map[props.node.type] || null;
});

const onUpdate = newData => {
  emit('update', props.node.id, newData);
};

const onDelete = () => {
  emit('delete', props.node.id);
};
</script>

<template>
  <div
    class="absolute left-4 top-4 bottom-4 z-20 flex flex-col rounded-xl bg-white dark:bg-n-surface-1 shadow-2xl overflow-y-auto w-[40rem]"
  >
    <div
      class="flex items-center justify-between px-4 py-3 bg-n-slate-1 dark:bg-n-slate-2 rounded-t-xl"
    >
      <h3 class="text-sm font-semibold text-n-slate-12 flex items-center gap-2">
        <span class="text-n-blue-5 i-lucide-settings-2 text-base" />
        {{ node.data?.label || node.type }}
      </h3>
      <div class="flex items-center gap-1">
        <Button
          v-if="node.type !== 'trigger'"
          variant="ghost"
          size="xs"
          color="ruby"
          icon="i-lucide-trash-2"
          @click="onDelete"
        />
        <Button
          variant="ghost"
          size="xs"
          icon="i-lucide-x"
          @click="emit('close')"
        />
      </div>
    </div>
    <div class="flex-1 p-4 flex flex-col gap-4">
      <component
        :is="editorComponent"
        v-if="editorComponent"
        :data="node.data"
        :inboxes="inboxes"
        @update="onUpdate"
      />
    </div>
  </div>
</template>
